/* eslint-disable react/no-unknown-property */
import { SaveBar } from "@shopify/app-bridge-react"
import { ContextualSaveBar } from "@shopify/polaris"
import { useCallbackWithLoading } from "polaris-enhance"

import { isShopifyEnv } from "@/utils/env-helper"

export interface PlatformSaveBarProps {
  open: boolean
  saving?: boolean
  onSave: () => Promise<any> | void
  onDiscard: () => void
  disabledConfirm?: boolean
  block?: (n, c) => boolean
}
const PlatformSaveBar = (props: PlatformSaveBarProps) => {
  const {
    onDiscard,
    onSave,
    open,
    disabledConfirm = false,
    saving: propSaving,
  } = props

  const [saving, save] = useCallbackWithLoading(async () => {
    await onSave()
  }, [onSave])

  if (isShopifyEnv) {
    return (
      <SaveBar id="shopify-save-bar" open={open}>
        <button
          variant="primary"
          loading={(propSaving ?? saving) ? "" : undefined}
          disabled={disabledConfirm}
          onClick={save}
        ></button>
        <button onClick={onDiscard}></button>
      </SaveBar>
    )
  }
  if (!open) return
  return (
    <ContextualSaveBar
      message={"Unsaved changes"}
      alignContentFlush
      saveAction={{
        onAction: save,
        loading: propSaving ?? saving,
        disabled: disabledConfirm,
        content: "Save",
      }}
      discardAction={{
        onAction: onDiscard,
        content: "Discard",
      }}
    />
  )
}
export default PlatformSaveBar
